var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import PropTypes from "prop-types";
import ChatContainer from "../ChatContainer.js";
import { fetchInitialConfig, initializeChat } from "../features/ChatBarActions.js";
import { resetChatState, resetConfigState } from "../features/ChatActions.js";
import { withChatContext } from "../Context.js";
class ChatBox extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleChatClose", () => {
      this.isClosingChat = true;
    });
    this.isClosingChat = false;
    if (this.props.initialConfig) {
      this.props.initializeChat(
        this.props.initialConfig,
        this.props.parcelCode,
        this.props.parcelNumber,
        this.props.orderId,
        this.props.postCode,
        this.props.caseId,
        this.props.collectionReference,
        this.props.collectionPostcode
      );
    }
  }
  componentDidMount() {
    if (!this.props.initialConfig) {
      this.props.fetchInitialConfig(
        this.props.parcelCode,
        this.props.parcelNumber,
        this.props.orderId,
        this.props.postCode,
        this.props.collectionReference,
        this.props.collectionPostcode
      );
    }
  }
  componentDidUpdate(prevProps) {
    const { config, caseId } = this.props;
    if ((!prevProps.caseId || prevProps.caseId === null) && caseId && caseId !== null) {
      this.props.initializeChat(
        config,
        this.props.parcelCode,
        this.props.parcelNumber,
        this.props.orderId,
        this.props.postCode,
        caseId,
        this.props.collectionReference,
        this.props.collectionPostcode
      );
    }
    if (prevProps.parcelCode !== this.props.parcelCode || prevProps.parcelNumber !== this.props.parcelNumber || prevProps.orderId !== this.props.orderId || prevProps.postCode !== this.props.postCode || prevProps.caseId !== this.props.caseId) {
      this.isClosingChat = true;
      this.props.resetStates();
      this.props.fetchInitialConfig(
        this.props.parcelCode,
        this.props.parcelNumber,
        this.props.orderId,
        this.props.postCode,
        this.props.collectionReference,
        this.props.collectionPostcode
      ).then(() => {
        if (this.props.initialConfig) {
          this.props.initializeChat(
            this.props.initialConfig,
            this.props.parcelCode,
            this.props.parcelNumber,
            this.props.orderId,
            this.props.postCode,
            this.props.caseId,
            this.props.collectionReference,
            this.props.collectionPostcode
          );
        }
      });
    }
  }
  componentWillUnmount() {
    if (this.isClosingChat) {
      this.props.resetStates();
    }
  }
  render() {
    var _a;
    return /* @__PURE__ */ jsx("div", { id: "chat-box", children: /* @__PURE__ */ jsx(
      ChatContainer,
      {
        show: true,
        businessUnit: this.props.config.businessUnit,
        isDragable: false,
        customizations: (_a = this.props) == null ? void 0 : _a.customizations,
        onMinimizeClick: this.props.hideChat,
        onChatClose: this.handleChatClose,
        ratingEnabled: this.props.ratingEnabled
      }
    ) });
  }
}
ChatBox.propTypes = {
  config: PropTypes.object,
  initialConfig: PropTypes.object,
  initializeChat: PropTypes.func,
  fetchInitialConfig: PropTypes.func,
  hideChat: PropTypes.func,
  customizations: PropTypes.object,
  ratingEnabled: PropTypes.bool,
  parcelCode: PropTypes.string,
  parcelNumber: PropTypes.string,
  caseId: PropTypes.string,
  orderId: PropTypes.string,
  postCode: PropTypes.string,
  collectionReference: PropTypes.string,
  collectionPostcode: PropTypes.string,
  apiClient: PropTypes.object,
  dispatch: PropTypes.func,
  resetStates: PropTypes.func
};
const mapStateToProps = (state) => ({
  config: state.chat.config
});
const mapDispatchToProps = (dispatch, { apiClient }) => ({
  initializeChat: (config, parcelCode, parcelNumber, orderId, postCode, caseId, collectionReference, collectionPostcode) => dispatch(
    initializeChat(
      config,
      apiClient,
      parcelCode,
      parcelNumber,
      postCode,
      orderId,
      caseId,
      collectionReference,
      collectionPostcode
    )
  ),
  fetchInitialConfig: (parcelCode, parcelNumber, orderId, postCode, collectionReference, collectionPostcode) => dispatch(
    fetchInitialConfig(
      apiClient,
      parcelCode,
      parcelNumber,
      orderId,
      postCode,
      collectionReference,
      collectionPostcode
    )
  ),
  dispatch,
  resetStates: () => {
    dispatch(resetChatState());
    dispatch(resetConfigState());
  }
});
const ChatBox$1 = compose(
  withChatContext,
  connect(mapStateToProps, mapDispatchToProps)
)(ChatBox);
export {
  ChatBox$1 as default
};
//# sourceMappingURL=ChatBox.js.map
